module.exports = __webpack_public_path__ + "static/media/id-popup-step1.7f09df3b.png";